<template>
  <div class="pt-2 pb-4">
    <div v-if="loading" class="no-access-permit">
      <feather-icon icon="LoaderIcon" size="48" class="loading-icon"/>
      <p class="no-access-text">데이터를 불러오는 중입니다.</p>
    </div>
    <div v-else-if="!list.length" class="no-access-permit">
      <feather-icon icon="AlertCircleIcon" size="48" class="no-access-icon"/>
      <p class="no-access-text">등록된 출입 허가가 없습니다.</p>
    </div>
    <template v-else>
      <div v-for="(item, index) of list" :key="item.id" class="item-card">
        <qr-access-item v-model="list[index]" @click="onClickItem(item)" />
      </div>
    </template>
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import QrAccessItem from "@/components/qr/QrAccessItem.vue";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";

export default {
  name: 'QrAccessList',
  components: {SimpleSpinner, QrAccessItem},
  emits: ['click-item'],
  props: {
    /* 리스트가 포함된 팝업이 열렸을 때 True로 변경된다 */
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  watch : {
    open() {
      if (this.open) {
        this.loadAccessList();
      }
    }
  },
  // mounted() {
  //   this.loadAccessList();
  // },
  methods: {
    async loadAccessList() {
      this.loading = true;
      const params = {
        page: 1,
        perPage: 20,
        boardIds: [976, 979],
      };

      // 오늘(yyyy-mm-dd) "body.작업허가.작업시작일시" 값을 찾도록 conditions 추가
      const conditions = [];
      const today = new Date().format('yyyy-MM-dd');
      conditions.push({key: 'body.작업허가.작업시작일시', operator: '<=', value: today})
      conditions.push({key: 'body.작업허가.작업종료일시', operator: '>=n', value: today})

      let conditionIndex = 0;
      for (const condition of conditions) {
        params[`conditions[${conditionIndex}][key]`] = condition.key;
        params[`conditions[${conditionIndex}][operator]`] = condition.operator;
        params[`conditions[${conditionIndex}][value]`] = condition.value;
        conditionIndex += 1;
      }

      HttpRequest.get('/api/v1/post/related', {params})
        .then((response) => {
          const {data} = response;
          this.lastPage = response.last_page;

          if (data.length < this.perPage) {
            this.list = data.concat(Array(this.perPage - data.length).fill({}));
          } else {
            this.list = data;
          }

        })
        .catch((err) => {
          console.log("err", err)
          this.customAlert('입출문 QR 데이터를 불러오는 중 오류가 발생했습니다.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickItem(item) {
      this.$emit('click-item', item);
    },

    customAlert(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "죄송합니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
  }
}
</script>

<style scoped lang="scss">
.no-access-permit {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
  text-align: center;
  color: #333;
  margin-top: 20px;
}

.no-access-icon {
  color: #ff4d4f;
  margin-bottom: 12px;
}

.loading-icon {
  color: #1890ff;
  margin-bottom: 12px;
  animation: spin 1s linear infinite;
}

.no-access-text {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}


</style>
